import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import AccountSettings from './../components/AccountSettings';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    domain: state.domain,
    business: state.business,
    staffManagement: state.StaffManagement
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);
